export default function Unauthorized() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Unauthorized</h2>
      <p>You don’t have permission to view this page.</p>
      <a href="/">Go to dashboard</a>
    </div>
  );
}
